import tippy from "tippy.js";
import "tippy.js/dist/tippy.css";
import { Alpine } from '../../../../vendor/livewire/livewire/dist/livewire.esm';

// Magic: $tooltip
Alpine.magic("tooltip", (el) => (content) => {
    const instance = tippy(el, { content, trigger: "manual", theme: "kala" });

    instance.show();

    setTimeout(() => {
        instance.hide();

        setTimeout(() => instance.destroy(), 150);
    }, 2000);
});

// Directive: x-tooltip
Alpine.directive("tooltip", (el, { expression, modifiers }, { cleanup }) => {
    const mobile = modifiers.indexOf("mobile") !== -1;
    const onlyOnEllipsis = modifiers.includes("only-on-ellipsis");
    const allowHTML = modifiers.indexOf("allowhtml") !== -1;
    const placement = el.getAttribute("placement");
    const maxWidth = el.getAttribute("tooltip-max-width");

    if (mobile && screen.width > 1023) return;

    const tooltip = tippy(el, {
        content: expression,
        theme: "kala",
        allowHTML,
        ...(placement && { placement: placement }),
        ...(maxWidth && { maxWidth: Number(maxWidth) }),
    });

    cleanup(() => {
        setTimeout(() => tooltip.destroy(), 1);
    })
    
    if (!onlyOnEllipsis) { 
        return;
    }

    el.addEventListener('mouseover', () => {
        const hasWidthDifference = el.offsetWidth >= el.scrollWidth

        const hasHeightDifference = el.offsetHeight >= el.scrollHeight

        if (hasWidthDifference && hasHeightDifference && !tooltip.state.isDestroyed) {
            tooltip.disable();
            
            return;
        }

        tooltip.enable();
    })
});

// Directive: x-dropdown-tooltip
// Use inside Flux dropdown/menus to avoid stacking-context issues.
Alpine.directive("dropdown-tooltip", (el, { expression }, { cleanup }) => {
    const placement = el.getAttribute("placement") || "top";
    const popoverRoot = el.closest?.('[popover]');
    const tooltipLayer = (() => {
        if (!popoverRoot) {
            return null;
        }

        // If we append the tooltip directly inside the menu, it can become part of the
        // scrollable overflow area and make the dropdown scroll. Instead, mount tooltips
        // into a fixed-position overlay layer inside the popover.
        if (popoverRoot.__kalaTooltipLayer instanceof HTMLElement) {
            return popoverRoot.__kalaTooltipLayer;
        }

        const layer = document.createElement('div');
        layer.setAttribute('data-kala-tooltip-layer', '');
        layer.style.position = 'fixed';
        layer.style.overflow = 'visible';
        layer.style.zIndex = '999999';

        popoverRoot.appendChild(layer);
        popoverRoot.__kalaTooltipLayer = layer;

        return layer;
    })();

    if (el._tippy) {
        el._tippy.destroy();
    }

    const tooltip = tippy(el, {
        content: expression,
        theme: "kala",
        placement,
        // Flux menus use the Popover API (top layer). Appending to body places the tooltip
        // behind the popover regardless of z-index. Append to the nearest popover root.
        appendTo: () => tooltipLayer ?? popoverRoot ?? document.body,
        zIndex: 999999,
        interactive: false,
        trigger: "mouseenter focus",
        popperOptions: {
            strategy: 'fixed',
            modifiers: [
                {
                    name: 'preventOverflow',
                    options: {
                        boundary: 'viewport',
                        altBoundary: true,
                        padding: 8,
                    },
                },
                {
                    name: 'flip',
                    options: {
                        fallbackPlacements: ['top', 'right', 'left', 'bottom'],
                    },
                },
            ],
        },
    });

    cleanup(() => {
        if (tooltip && !tooltip.state.isDestroyed) {
            tooltip.destroy();
        }
    });
});
